//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Draggable } from "vue-smooth-dnd";
import EditMediaModal from "./EditMediaModals/EditMediaModalDark";
import DeleteMediaModal from "./DeleteMediaModal";
import { mapActions } from "vuex";
import sharedMethods from "../../sharedMethods";

export default {
  name: "content-card",
  props: ["content", "multiSelectOn", "isSelectedItem", "selectedItemCount"],

  components: { Draggable, EditMediaModal },
  data() {
    return {
      msg: "Mirrads Media Modal",
      orientationModel: "",
      info: [],
      random: 1,
      secretMessage: "",
      processing: false,
      loading: false,
      username: "",
      uploadPercentage: "",
      filename: "",
      inUsePl: [],
      searchQuery: "",
      host: "",
      api: "",
      modalEditContent: false,
      accID: this.$store.getters.getUser.AccID,
      isDisabled: false,
      showEditMediaModal: false,
      cardHovered: false,
    };
  },

  computed: {
    isVideoOrImage() {
      return this.content.mimetype === "video" || this.content.mimetype === "image";
    },
    sharedMethods() {
      return sharedMethods;
    },
  },
  beforeDestroy() {
    // TODO REMOVE VIDEO
    if (this.$refs.myVideo1) {
      this.$refs.myVideo1.remove();
      this.$refs.myVideo1.src = "";
      this.$refs.myVideo1.srcObject = null;
    }
    if (this.$refs.myVideo2) {
      this.$refs.myVideo2.remove();
      this.$refs.myVideo2.src = "";
      this.$refs.myVideo2.srcObject = null;
    }
  },

  destroyed() {
    // console.log('DESTROY');
  },

  methods: {
    ...mapActions(["checkIfContentIsInAPlaylist"]),

    getIcon(content) {
      let mimetype = content.contentGroup ? content.contentGroup[0].mimetype : content.mimetype;
      switch (mimetype) {
        case "video":
          return "movie";
        case "webview":
        case "veomo":
          return "language";
        case "youtube":
          return "fab fa-youtube";
        case "plug":
          return "branding_watermark";
        case "image":
          return "image";
        case "image/pdf":
          return "image";
        default:
          return "fab fa-instagram";
      }
    },

    checkUsedMedia(contentIds) {
      this.checkIfContentIsInAPlaylist(contentIds).then((response) => {
        this.inUsePl = response.data;

        // delete a single file
        this.$q.dialog({
          component: DeleteMediaModal,
          root: this,
          inUsePl: this.inUsePl,
          contentsToDelete: [this.content],
        });
      });
    },

    openEditMenu() {
      this.showEditMediaModal = !this.showEditMediaModal;
    },
  },
};
